import { Button, Divider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragrance, FragranceId } from '~/api/api.declaration';
import { UIService } from '~/service/service.ui';
import { FragranceUpdateDto } from '~/shared/dto/admin/fragrance.dto';
import { Form } from '~/shared/form';
import { useService } from '~/shared/service/service.base';
import { FragranceASINsDialog } from '~/view/dialog/dialog.fragrance.asins';
import { FragranceOffersDialog, FragranceRakutenOffersDialog } from '~/view/dialog/dialog.fragrance.offers';
import { Col, Row, Text } from '~/view/view.box';

type FragranceAffiliateProps = {
	form: Form<FragranceUpdateDto, Fragrance>;
	reload: () => void;
};
export const FragranceAffiliate = observer<FragranceAffiliateProps>(({ form, reload }) => {
	const [ui] = useService(UIService);
	const id = form.initial?.id;

	return (
		<Col gap={4}>
			{id && <FragranceOffersDialog fragranceId={id as FragranceId} />}
			{id && <FragranceASINsDialog form={form} reload={reload} />}
			{id && <FragranceRakutenOffersDialog fragranceId={id as FragranceId} />}
			<Col gap={2}>
				<Text variant="h6" color="text.secondary" textTransform="uppercase">
					Amazon Associates
				</Text>
				<Row gap={1} justifyContent="flex-start">
					<Button variant="contained" onClick={() => ui.showDialog(FragranceASINsDialog)}>
						Show ASIN from Amazon
					</Button>
					<Button variant="contained" onClick={() => ui.showDialog(FragranceOffersDialog)}>
						Show offers from Amazon
					</Button>
				</Row>
			</Col>
			<Divider />
			<Col gap={2}>
				<Text variant="h6" color="text.secondary" textTransform="uppercase">
					Rakuten Advertising
				</Text>
				<Row gap={1} justifyContent="flex-start">
					<Button variant="contained" onClick={() => ui.showDialog(FragranceRakutenOffersDialog)}>
						Show offers from Rakuten
					</Button>
				</Row>
			</Col>
		</Col>
	);
});
